import { getCookie, setCookie, uuid } from './utils'
import Cache from './cache'

export interface Options {
  pid: string
  bid?: string
  url?: string
  random?: number
  limit?: number
  disabled?: boolean,
  version?: string
}

export interface Event {
  type: string
  name: string
  value: string
}

export interface UserInfo {
  uid: string
  [index: string]: string
}

export default class Snaker {
  pid: string
  bid?: string
  url: string
  user?: UserInfo
  random: number
  limit: number
  uuid: string
  prefix: string
  cache: Cache
  disabled?: boolean
  version?: string

  constructor(options: Options) {
    if (!options.pid) throw new Error('product id is required!')

    const { pid, bid, url, random, limit, disabled, version } = options
    this.pid = pid
    this.bid = bid
    this.random = random || 1
    this.limit = limit || 5
    this.disabled = disabled
    this.version = version || ''
    this.url = url || 'https://da.dun.163.com/sn.gif'
    this.prefix = '__snaker__id'

    this.cache = new Cache(this.prefix)

    const localCacheInfo = getCookie(this.prefix)
    if (localCacheInfo) {
      this.uuid = localCacheInfo
    } else {
      this.uuid = uuid()
      setCookie(this.prefix, this.uuid, 1000 * 60 * 60 * 24 * 365)
    }
  }

  setUser(user: string | UserInfo) {
    if (typeof user === 'string') {
      this.user = {
        uid: user
      }
    } else {
      this.user = { uid: user.uid }
      for (let key in user) {
        if (!user.hasOwnProperty(key)) {
          continue
        } else {
          if (key !== 'uid') this.user['$user_' + key] = user[key]
        }
      }
    }
  }

  serialize(data: Event, extra: object): string {
    const { pid, bid, uuid, user, version } = this
    const { type, name, value } = data
    const slice = (str: string, len: number): string => str.substring(0, len)

    const resolution: string = screen.width + 'x' + screen.height
    const pageUrl = slice(location.href, 200)
    const now = new Date().getTime() + ''

    const params: { [index: string]: string | undefined } = {
      pid,
      bid,
      uuid,
      type,
      name,
      version,
      value,
      res: resolution,
      pu: pageUrl,
      nts: now,
      ...extra,
      ...user
    }

    const query: string[] = []
    for (let key in params) {
      if (!params.hasOwnProperty(key)) {
        continue
      } else {
        if (params[key] !== undefined) {
          query.push(encodeURIComponent(key + '=') + encodeURIComponent(encodeURIComponent(params[key] as string)))
        } else {
          continue
        }
      }
    }
    return query.join('%26')
  }

  sendRequest(server: string, data: string): void {
    if(this.disabled) return

    const image = new Image(1, 1)
    image.src = server + '?d=' + data
  }

  report(type: string, name: string, value: string, offline?: boolean, extra?: object): void {
    if(this.disabled) return
    if (this.random < Math.random()) return

    const log = this.serialize({ type, name, value }, extra ? extra : {})
    if (offline) {
      this.cache.push(log)
      if (this.cache.length() >= this.limit) {
        this.flush()
      }
    } else {
      this.sendRequest(this.url, log)
    }
  }

  track(type: string, name: string, value: string, extra?: object) {
    this.report(type, name, value, false, extra)
  }

  trackAsync(type: string, name: string, value: string, extra?: object) {
    this.report(type, name, value, true, extra)
  }

  flush() {
    let payload: string = ''
    const logs = this.cache.pop(this.limit)

    while (logs.length) {
      let poped = logs.pop() || ''
      if (!poped) continue
      payload = payload ? payload + ',' + poped : poped
      if (payload.length > 1800) {
        this.sendRequest(this.url, payload)
        payload = ''
      }
    }

    if(payload) {
      this.sendRequest(this.url, payload);
    }
  }
}
